import styled, { keyframes } from "styled-components";
// eslint-disable-next-line no-unused-vars
import _default from "../../themes/default";

// eslint-disable-next-line no-unused-vars
const float = keyframes`
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-15px); }
`;

// eslint-disable-next-line no-unused-vars
const pulseGlow = keyframes`
  0%, 100% { box-shadow: 0 0 30px rgba(133, 76, 230, 0.4); }
  50% { box-shadow: 0 0 50px rgba(133, 76, 230, 0.6), 0 0 80px rgba(133, 76, 230, 0.3); }
`;

export const HeroContainer = styled.div`
  background: linear-gradient(180deg, ${({ theme }) => theme.card_light} 0%, ${({ theme }) => theme.bg} 100%);
  display: flex;
  justify-content: center;
  position: relative;
  padding: 100px 30px 120px 30px;
  min-height: 100vh;
  @media (max-width: 960px) {
    padding: 80px 16px;
  }
  @media (max-width: 640px) {
    padding: 60px 16px;
  }
  z-index: 1;
  overflow: hidden;
`;

export const HeroBg = styled.div`
  position: absolute;
  display: flex;
  justify-content: end;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-width: 1360px;
  overflow: hidden;
  padding: 0 30px;
  top: 50%;
  left: 50%;
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
  opacity: 0.6;

  @media (max-width: 960px) {
    justify-content: center;
    padding: 0 0px;
  }
`;

export const HeroInnerContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  gap: 40px;

  @media (max-width: 960px) {
    flex-direction: column;
  }
`;

export const HeroLeftContainer = styled.div`
  width: 100%;
  order: 1;
  @media (max-width: 960px) {
    order: 2;
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @media (max-width: 640px) {
    order: 2;
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const HeroRightContainer = styled.div`
  width: 100%;
  display: flex;
  order: 2;
  justify-content: center;
  align-items: center;
  gap: 12px;
  
  @media (max-width: 960px) {
    order: 1;
    justify-content: center;
    align-items: center;
    margin-bottom: 40px;
  }

  @media (max-width: 640px) {
    margin-bottom: 20px;
  }
`;

export const Img = styled.img`
  position: relative;
  width: 100%;
  height: 20.5rem;
  max-width: 400px;
  max-height: 400px;
  border-radius: 50%;
  border: 3px solid ${({ theme }) => theme.primary};
  box-shadow: 0 0 30px rgba(133, 76, 230, 0.4);
  transition: all 0.4s ease-in-out;
  
  &:hover {
    box-shadow: 0 0 50px rgba(133, 76, 230, 0.6);
    transform: scale(1.02);
  }

  @media (max-width: 768px) {
    max-width: 400px;
    max-height: 400px;
  }

  @media (max-width: 640px) {
    max-width: 280px;
    max-height: 280px;
  }
`;

export const Title = styled.div`
  font-weight: 700;
  font-size: 52px;
  color: ${({ theme }) => theme.text_primary};
  line-height: 1.2;
  margin-bottom: 8px;
  
  @media (max-width: 960px) {
    text-align: center;
  }

  @media (max-width: 640px) {
    font-size: 36px;
    line-height: 1.3;
    margin-bottom: 8px;
  }
`;

export const TextLoop = styled.div`
  font-weight: 600;
  font-size: 28px;
  display: flex;
  gap: 12px;
  color: ${({ theme }) => theme.text_primary};
  line-height: 1.5;
  margin-bottom: 16px;
  flex-wrap: wrap;
  
  @media (max-width: 960px) {
    text-align: center;
    justify-content: center;
  }
  @media (max-width: 640px) {
    font-size: 20px;
    line-height: 1.4;
    margin-bottom: 16px;
  }
`;

export const Span = styled.span`
  color: ${({ theme }) => theme.primary};
  cursor: pointer;
`;

export const TypewriterWrapper = styled.div`
  background: rgba(133, 76, 230, 0.1);
  border: 1px solid rgba(133, 76, 230, 0.3);
  border-radius: 8px;
  padding: 4px 16px;
  font-family: 'Fira Code', 'Courier New', monospace;
  
  .Typewriter__cursor {
    color: ${({ theme }) => theme.primary};
    font-weight: 100;
    animation: blink 1s infinite;
  }
  
  @keyframes blink {
    0%, 50% { opacity: 1; }
    51%, 100% { opacity: 0; }
  }
`;

export const SubTitle = styled.div`
  font-size: 18px;
  line-height: 1.7;
  margin-bottom: 36px;
  color: ${({ theme }) => theme.text_secondary};
  max-width: 500px;

  @media (max-width: 960px) {
    text-align: center;
  }

  @media (max-width: 640px) {
    font-size: 16px;
    line-height: 1.6;
  }
`;

export const ResumeButton = styled.a`
    -webkit-appearance: button;
    -moz-appearance: button;
    appearance: button;
    text-decoration: none;
    width: 95%;
    max-width: 220px;
    text-align: center;
    padding: 14px 28px;
    color: ${({ theme }) => theme.white};
    border-radius: 50px;
    cursor: pointer;
    font-size: 16px;
    font-weight: 600;
    transition: all 0.3s ease !important;
    background: linear-gradient(135deg, #854CE6 0%, #6366f1 100%);
    box-shadow: 0 10px 30px rgba(133, 76, 230, 0.3);
    position: relative;
    overflow: hidden;
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
      transition: left 0.5s ease;
    }
    
    &:hover {
        transform: translateY(-3px);
        box-shadow: 0 15px 40px rgba(133, 76, 230, 0.4);
        
        &::before {
          left: 100%;
        }
    }    
    
    &:active {
        transform: translateY(-1px);
    }
    
    @media (max-width: 640px) {
        padding: 12px 24px;
        font-size: 15px;
    } 
`;
